import Route from "@ember/routing/route";
import type RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import type Patient from "parog-web/models/patient";
import type FetcherService from "parog-web/services/fetcher";
import type NavigationService from "parog-web/services/navigation";

/**
 * This route is used to have the same link for mailing and remindering.
 * Its goal is to redirect to a new session if no session exist or to redirect to the edition
 * route otherwise.
 */
export default class BloodPressureRoute extends Route {
  @service declare router: RouterService;
  @service declare navigation: NavigationService;
  @service declare fetcher: FetcherService;

  async model() {
    await this.fetcher.loadRecords(
      "blood-pressure-session-started-journal-event",
      {
        filter: { patient_id: this.patient.id },
        include: "blood-pressure-measured-journal-events"
      }
    );
  }

  afterModel(): void {
    const session = this.patient.lastBloodPressureSessionStartedJournalEvent;

    if (!session || !session.isOpened) {
      this.router.transitionTo(
        `${this.navigation.currentPatientRouteName}.blood-pressure.sessions.new`
      );
    } else {
      this.router.transitionTo(
        `${this.navigation.currentPatientRouteName}.blood-pressure.sessions.session`,
        session.id
      );
    }
  }

  get patient() {
    return this.modelFor(
      `${this.navigation.currentPatientRouteName}`
    ) as Patient;
  }
}
